<template>
  <ActionDialog
    v-for="entry in activeEntries"
    :key="entry.id"
    v-bind="entry.options"
    :done-action="entry.confirm"
    :cancel-action="entry.cancel"
    eager
    persistent
    pad
  />
</template>

<script lang="ts">
import { defineComponent, computed, watch } from "vue";
import { useConfirmStore } from "../private/confirm";

export default defineComponent({
  name: "ConfirmDialog",
  setup() {
    const { entries, cleanup } = useConfirmStore();
    const route = useRoute();

    // Filter out entries that are closing to prevent reopening
    const activeEntries = computed(() => {
      return entries.value
        .filter((entry) => !entry.closing)
        .map((entry) => ({
          ...entry,
          options: {
            ...entry.options,
            inputs: entry.options.inputs as any,
          },
        }));
    });

    // Clean up all dialogs on route change
    watch(() => route.path, cleanup);

    return {
      activeEntries,
    };
  },
});
</script>
